exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".LookupHelper_container__3f6ai{width:100%}.LookupHelper_container__3f6ai .LookupHelper_group__U-0RN{color:#4285f4 !important}[dir=ltr] .LookupHelper_container__3f6ai .LookupHelper_group__U-0RN{margin-left:-10px}[dir=rtl] .LookupHelper_container__3f6ai .LookupHelper_group__U-0RN{margin-right:-10px}.LookupHelper_container__3f6ai .ant-select-dropdown-menu-item-group-title{display:none}", ""]);

// Exports
exports.locals = {
	"container": "LookupHelper_container__3f6ai",
	"group": "LookupHelper_group__U-0RN"
};